import React from 'react';
import FormField from 'mrf/view/FormField';
import Input from 'mrf/view/Input';

const valueMapper = e => e.target.value;

export default function TextField({
    lines = 1,
    multiline = false,
    ...props
}) {
    return (
        <FormField
            as={multiline ? 'textarea' : 'input'}
            type='text'
            rows={lines}
            component={Input}
            eventMapper={valueMapper}
            {...props}
        />
    );
}
